import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";

import { DayBarChart } from "~/components/day-bar-chart";
import {
  type DayCount,
  fillDateGaps,
  chartDateRange,
} from "~/lib/shared/day-chart";
import { purple } from "~/lib/ui";

export const getDiscoveriesByDay = createServerFn({ method: "GET" }).handler(
  async (): Promise<Array<DayCount>> => {
    const { getDBWithInit } = await import("~/lib/db");
    const { userPreferences } = await import("~/../drizzle/schema");
    const { sql, and, gte, lt } = await import("drizzle-orm");

    const { rangeStart, rangeEnd } = chartDateRange(30, 0);
    const db = await getDBWithInit();

    const rows = await db
      .select({
        date: sql<string>`DATE(${userPreferences.createdAt})`.as("date"),
        count: sql<number>`COUNT(*)::int`.as("count"),
      })
      .from(userPreferences)
      .where(
        and(
          gte(userPreferences.createdAt, rangeStart),
          lt(userPreferences.createdAt, rangeEnd),
        ),
      )
      .groupBy(sql`DATE(${userPreferences.createdAt})`)
      .orderBy(sql`DATE(${userPreferences.createdAt})`);

    return fillDateGaps(rows, {
      daysBefore: 30,
      daysAfter: 0,
      pastColor: purple[400],
      futureColor: purple[200],
    });
  },
);

function DiscoveryChartPage() {
  const { data } = Route.useLoaderData();
  return (
    <DayBarChart data={data} noun="Discoveries" rangeLabel="last 30 days" />
  );
}

export const Route = createFileRoute("/embed/discovery-chart/")({
  head: () => ({
    title: "Discovery Chart - Dream Coach Match",
    meta: [
      {
        name: "description",
        content: "Embedded chart showing completed discovery flows over time",
      },
    ],
  }),
  loader: async () => {
    const data = await getDiscoveriesByDay();
    return { data };
  },
  component: DiscoveryChartPage,
});
